import { environment } from '../environments/environment';

const BASE_URL = environment.REACT_APP_BASE_URL;
const API_V1 = `${BASE_URL}/api/v1/`;
const API_V2 = `${BASE_URL}/api/v2/`;
const REACT_APP_MIDDLEWARE_URL = `${BASE_URL}/doconmw/`;
const LANNISTERS_URL = `${BASE_URL}/lannisters/`;
const GRAPHQL = `${BASE_URL}/graphql/`;

const apiMap = {
  login: `${API_V1}user/online-login`,
  verifyOtp: `${API_V1}user/authenticate-login`,
  checkConsentStatus: (phoneNumber) => `${REACT_APP_MIDDLEWARE_URL}patientConsent/WHATSAPP/status?countryCode=91&phone_number=${phoneNumber}`,
  whatsappOptIn: `${REACT_APP_MIDDLEWARE_URL}patientConsent/WHATSAPP/OPT_IN`,
  whatsappOptOut: `${REACT_APP_MIDDLEWARE_URL}patientConsent/WHATSAPP/OPT_OUT`,
  update: (userID: string) => `${API_V1}user/${userID}`,
  getPrescriptions: (userID: string) => `${API_V1}user/${userID}/visits`,
  getPrescriptionSamsung: (visitID: string) => `${API_V2}emr/visits/${visitID}/prescription-html-patient`,
  getPdfUrl: (url: string) => `${LANNISTERS_URL}${url}`,
  getFaqs: () => `${LANNISTERS_URL}support/faqs/`,
  featuresEnabled: (docID: string) => `${REACT_APP_MIDDLEWARE_URL}eim/feature/medicine-fulfilment-flags?doctor_id=${docID}`,
  featuresEnabledAllDoctors: (userID: string) => `${API_V1}user/${userID}/features_enabled`,
  getDashboardData: (userID: string) => `${API_V1}user/${userID}/dashboard`,
  diagnosticOrder: () => `${REACT_APP_MIDDLEWARE_URL}eim/lab/orders`,
  graphQL: `${GRAPHQL}`,
  logout: (token: string) => `${API_V1}token/${token}`,
  getClinics: () => `${API_V1}doctor/clinic-details`,
  getClinicDetails: (clinicID: string) => `${API_V1}clinic/${clinicID}/public`,
  getVcPrice: () => `${REACT_APP_MIDDLEWARE_URL}patient-app/pricing`,
  getDoctorDetails: (shortUrl: string) => `${API_V1}doctor/${shortUrl}/public`,
  searchDoctor: () => `${API_V1}doctor/search`,
  getAggregateData: (userID: string) => `${API_V1}user/${userID}/aggregate-data`,
  getDiscountBanner: () => `${API_V2}banners`,
  // https://alpha.docon.co.in/api/v1/appointment/2276351
  getCartItems: () => `${BASE_URL}/doconmw/eim/lab/cart-items`,
  getProfileToken: (appointmentId: string) => `${API_V1}appointment/${appointmentId}/profile-token`,
  getReceipt: (paymentId: string) => `${BASE_URL}/munshi/munshi-service/document/TELECONSULT_PAYMENT/${paymentId}/PATIENT_PAYMENT_RECEIPT`,
  getAppointment: (appointmentId: string) => `${API_V1}appointment/${appointmentId}`,
  getAppointments: () => `${API_V1}appointments`,
  checkCancelEligibility: (sessionId: string) => `${BASE_URL}/lannisters/teleconsult/sessions/${sessionId}/cancel/`,
  cancelAppointment: (sessionId: string) => `${BASE_URL}/lannisters/teleconsult/sessions/${sessionId}/confirm_cancel_refund/`,
  deleteAppointment: ({ isTeleConsult, teleConsultSessionID, appointmentID }: any) => {
    if (isTeleConsult)
      return `${BASE_URL}/lannisters/teleconsult/sessions/${teleConsultSessionID}/cancel/`;

    return `${API_V1}appointment/${appointmentID}`;
  },
  bookAppointment: ({ isTeleConsult }: any) => {
    if (isTeleConsult)
      return `${BASE_URL}/lannisters/teleconsult/sessions/`;

    return `${API_V1}appointment`;
  },
  bookZeroFeeTeleConsult: (sessionId: string) => {
    return `${BASE_URL}/lannisters/teleconsult/sessions/${sessionId}/confirm/`;
  },
  rescheduleAppointment: ({ isTeleConsult, teleConsultSessionID, appointmentID }: any) => {
    if (isTeleConsult)
      return `${BASE_URL}/lannisters/teleconsult/sessions/${teleConsultSessionID}/reschedule/`;

    return `${API_V1}appointment/${appointmentID}`;
  },
  getTeleConsultSession: (sessionId: number) => {
    return `${BASE_URL}/lannisters/teleconsult/sessions/${sessionId}/`;
  },
  getLatestTeleConsultPayment: (sessionId: number) => {
    return `${BASE_URL}/lannisters/teleconsult/sessions/${sessionId}/latest_payment/`;
  },
  initiateTeleConsultPayment: (sessionId: number) => {
    return `${BASE_URL}/lannisters/teleconsult/sessions/${sessionId}/initiate_payment/`;
  },
  getTeleConsultPricing: () => {
    return `${BASE_URL}/doconmw/teleconsult/sessions/pricing_details/`;
  },
  getHelpAndSupport: () => `${BASE_URL}/lannisters/support/queries/`,
  getUserPatients: (userID: string) => `${API_V1}user/${userID}/patients`,
  createNewPatient: () => `${API_V1}user/create-patient`,
  getUserDetailsFromToken: (accessToken: string) => `${API_V1}token/${accessToken}`,
  checkVisitID: (visitID: string) => `${API_V1}user/visit-by-id?visitID=${visitID}`,
};
export default apiMap;